/**
 * Константы для действий модерации
 */
export const MODERATOR_ACTIONS = {
    MUTE: 'MUTE', // выключить микрофон
    DISABLE_VIDEO: 'DISABLE_VIDEO', // выключить видео
    MUTE_ALL_EXCEPT: 'MUTE_ALL_EXCEPT', // выключить микрофон всем кроме таргета
    DISABLE_VIDEO_ALL_EXCEPT: 'DISABLE_VIDEO_ALL_EXCEPT', // выключить видео всем кроме таргета
    REMOVE_FROM_CALL: 'REMOVE_FROM_CALL', // удалить участника из звонка
    INVITE_TO_SPEAK: 'INVITE_TO_SPEAK', // попросить высказаться, для участника с выключенным микрофоном
    MAKE_MODERATOR: 'MAKE_MODERATOR', // назначить модератором, может только основной модератор
    REVOKE_MODERATOR: 'REVOKE_MODERATOR', // отозвать роль модератора
    MAKE_SPEAKER: 'MAKE_SPEAKER', // назначить спикером в режиме вебинара
    REVOKE_SPEAKER: 'REVOKE_SPEAKER', // отозвать право спикера в режиме вебинара
    START_WEBINAR: 'START_WEBINAR', // broadcast: модератор включил режим вебинара
    END_WEBINAR: 'END_WEBINAR', // broadcast: модератор отключил режим вебинара
    WEBINAR_FORCE_MIC_OFF: 'WEBINAR_FORCE_MIC_OFF', // broadcast: выключить микрофоны слушателей (не модераторов/спикеров)
    WEBINAR_FORCE_CAM_OFF: 'WEBINAR_FORCE_CAM_OFF', // broadcast: выключить камеры слушателей
    WEBINAR_FORCE_SCREEN_SHARE_OFF: 'WEBINAR_FORCE_SCREEN_SHARE_OFF', // broadcast: принудительно остановить шаринг экрана у слушателей
} as const;

export type ModeratorAction = (typeof MODERATOR_ACTIONS)[keyof typeof MODERATOR_ACTIONS];

/**
 * Названия действий для логирования ошибок валидации SID участника
 */
export const MODERATION_ACTION_NAMES = {
    MUTE_MIC: 'заглушить микрофон',
    INVITE_TO_SPEAK: 'попросить высказаться',
    MUTE_CAM: 'выключить камеру',
    OPEN_MUTE_MIC_OTHERS_CONFIRM: 'открыть подтверждение заглушения микрофонов остальных',
    OPEN_MUTE_CAM_OTHERS_CONFIRM: 'открыть подтверждение выключения камер остальных',
    OPEN_KICK_CONFIRM: 'открыть подтверждение исключения',
    OPEN_MUTE_OTHERS_FROM_LOCAL_TILE_MIC_CONFIRM: 'открыть подтверждение мьюта участников',
    OPEN_MUTE_OTHERS_FROM_LOCAL_TILE_CAM_CONFIRM: 'открыть подтверждение выключения камер для участников',
    MAKE_SPEAKER: 'назначить спикером',
    REVOKE_SPEAKER: 'отозвать право спикера',
} as const;
